import { gql } from "@apollo/client";

export const GET_CLIENTE_LITE = gql`
query GetClienteByCodigo (
    $codigo: String!
){
    clienteByCodigo(codigo: $codigo ) {
        success,
        error,
        valorEsperado {
            nom_Com,
            cod_Cliente,
            provincia
            cUIT
        }
    }
}
`;

export const clienteDataAdapter = (data) => {
  return {
    nombre: data?.nom_Com,
    codSap: data?.cod_Cliente,
    oficinaVentas: data?.provincia,
    cuit: data?.cUIT
  };
};